
export default {
    makeRecordId(iso_date, activity_id){
        return iso_date+"_"+activity_id;
    },
}